(function ($) {

  $('document').ready(setup);

  function setup() {
    initLazyLoad();
    sliderHome();
    sliderHomeMini();
    sliderProduct();
    sliderPhoto();
    tabsProducts();
    moreLoadRealizations();
    parallaxBlockwhyakena();
    buttonMyProject();
    uploadFormRDV();
    filterViewAdvice();

    selectlangmobile();
    initFAQBlock();

    $('.blockvideo').click(showVideo);

    // Landing page
    $("#call-to-action-landing-page").click(callFormLandingPage);
    $("#close-to-action-landing-page").click(closeFormLandingPage);
    if ($("main.landing-page").length) {
      if ($(".webform-confirmation__message").length) {
        $(".webform-confirmation__message").parents('.section-right').css('transform', 'translate(0px)');
      }
    }

    $('.see-more').click(seeMore);

    // Form de Mon projet par étape
    //$('.webform-submission-prise-de-rendez-vous-je-precise--form .webform-button--next').click(verifFormRDV);
    //$('.webform-submission-prise-de-rendez-vous-je-precise--form .webform-button--submit').click(verifFormRDV);
    // Form de contact
    //$('.webform-submission-contact-form .edit-actions-submit').click(verifFormContact);
    // Form Demande de catalogue
    //$('.webform-submission-demande-de-catalogue-form .edit-actions-submit').click(verifFormContact);

    // Object Image IE
    $('.image img').addClass('img-obj-fit');
    if ('objectFit' in document.documentElement.style === false) {
      objectFitIt();
    }

    /**
     * Forcing Recapcha v2 (Mobile)
     */
    function isPuzzleDisplayed(selector) {
      return document.querySelectorAll(selector).length >= 1;
    }

    var timer = setInterval(function () {
      if (isPuzzleDisplayed('iframe[title*="recaptcha challenge"]')) {
        $('iframe[title*="recaptcha challenge"]').each(function (index) {
          $('iframe[title*="recaptcha challenge"]').parent().parent().addClass('g-recaptcha-puzzle');
        });
        clearInterval(timer);
        timer = 0;
      }
    }, 0);

    $(document).ajaxComplete(function () {
      initLazyLoad();

      var timer = setInterval(function () {
        if (isPuzzleDisplayed('iframe[title*="recaptcha challenge"]')) {
          setTimeout(function () {
            $('iframe[title*="recaptcha challenge"]').each(function (index) {
              $('iframe[title*="recaptcha challenge"]').parent().parent().addClass('g-recaptcha-puzzle');
            });
          }, 2500);
          clearInterval(timer);
          timer = 0;
        }
      }, 0);
      $(document).ready(function () {
        $(window).on('resize', function () {
          resizeReCaptcha();
        });
        resizeReCaptcha();
      });
    });

    function resizeReCaptcha() {
      var width = $('.g-recaptcha').parent().width();
      if (width < 302) {
        var scale = width / 302;
        $('.g-recaptcha').css('transform', 'scale(' + scale + ')');
        $('.g-recaptcha').css('-webkit-transform', 'scale(' + scale + ')');
        $('.g-recaptcha').css('transform-origin', '0 0');
        $('.g-recaptcha').css('-webkit-transform-origin', '0 0');
      }
    };

    $('.menu-burger').click(showMenu);
    $('.akena-and-you-mobile h2').click(showUnderMenu);
    $('#block-navigationprincipale .is-active').click(showSubMenu);
    if (window.matchMedia("(max-width:1200px)").matches) {
      $('.dropdown-menu a').click(showSubMenu);
    }

    $(window).scroll(minifyHeader);
    $(window).resize(removeMinifyHeader);

    datePickerFormRDV();

    $(document).ajaxComplete(function () {
      datePickerFormRDV();
    });

    if ($(".blockgalleryphoto").length) {
      fancybox();
    }
  }

  function fancybox() {
    $('[data-fancybox="gallery"]').fancybox({
      buttons: [
        "slideShow",
        "zoom",
        "fullScreen",
        "close"],
      loop: false,
      protect: true
    });
  }

  // Fonction qui check pendant un upload d'un fichier
  function uploadFormRDV() {
    $("input[name$='photo_de_la_facade_de_la_maison_upload_button']").hide();
    $('[id^=edit-photo-de-la-facade-de-la-maison-upload]').on('change', function (e) {
      e.preventDefault();
      $('input#edit-photo-de-la-facade-de-la-maison-upload-button').mousedown();
    });
  }

  // Init Lazy Load
  function initLazyLoad() {
    var ll = new LazyLoad({
      threshold: 0,
    });
  }

  // Filtre de la vue des conseils sous mobile
  function filterViewAdvice() {
    if (window.matchMedia("(max-width:760px)").matches) {
      var lang = drupalSettings.path.currentLanguage;
      if(lang === 'es'){
        $("<span class='filters-list-categorie-advice'><span class='filter'>Filtros :</span><svg class='icon-arrow'><use xlink:href='../themes/custom/akena/images/sprites.svg#icone-fleche-droite'></use></svg></span>").insertAfter(".views-advice header");
      } else if(lang === 'it'){
        $("<span class='filters-list-categorie-advice'><span class='filter'>Filtri :</span><svg class='icon-arrow'><use xlink:href='../themes/custom/akena/images/sprites.svg#icone-fleche-droite'></use></svg></span>").insertAfter(".views-advice header");
      } else{
        $("<span class='filters-list-categorie-advice'><span class='filter'>Filtres :</span><svg class='icon-arrow'><use xlink:href='../themes/custom/akena/images/sprites.svg#icone-fleche-droite'></use></svg></span>").insertAfter(".views-advice header");
      }
      $(".links-list").hide();
    }
    $(".filters-list-categorie-advice").on('click', function (e) {
      e.preventDefault();
      $(".links-list").toggle();
    });
  }

  function selectlangmobile(){
    $('.akena-lang-mobile .is-active').click(function (e){
      e.preventDefault();
      $('.language-link:not(.is-active)').toggleClass('open');
    });
  }

  function initFAQBlock() {
    $('.blockwysiwyg-faq').click(function() {
      if($(this).hasClass('open')) {
        $(this).removeClass('open');
        $(this).find('.blockwysiwyg-text').slideUp(400);
      }else {
        $(this).addClass('open');
        $(this).find('.blockwysiwyg-text').slideDown(400);
      }
    });
  }

  // Fonction Scrool "Accueil" du Formulaire RDV
  function buttonMyProject() {
    $('#my-project').click(function () {
      position = $('#webform-progress-bar-my-project').offset().top;
      if ($(window).width() > 1200) {
        positions = position - 100;
      } else {
        positions = position;
      }

      $('html, body').animate({
        scrollTop: positions
      }, 1000)
    })
  }

  // Fonction DatePicker Formulaire RDV
  function datePickerFormRDV() {
    if (window.matchMedia("(min-width:1024px)").matches) {
      $('.edit-calendrier-des-rendez-vous-items-0-le').datepicker({
        minDate: new Date(),
      })
      $('.edit-calendrier-des-rendez-vous-items-1-le').datepicker({
        minDate: new Date(),
      })
      $('.edit-calendrier-des-rendez-vous-items-2-le').datepicker({
        minDate: new Date(),
      })
    } else {
      $('.edit-calendrier-des-rendez-vous-items-0-le').removeAttr("readonly");
      $('.edit-calendrier-des-rendez-vous-items-1-le').removeAttr("readonly");
      $('.edit-calendrier-des-rendez-vous-items-2-le').removeAttr("readonly");
    }
  }

  // Fonction parallax "Pourquoi Akena"
  function parallaxBlockwhyakena() {
    var bgblockwhyakena = document.getElementById('bg-blockwhyakena');
    if (bgblockwhyakena) {
      new simpleParallax(bgblockwhyakena, {
        delay: .100,
        transition: 'cubic-bezier(0,0,0,1)'
      });
    }
  }

  // Fonction plus de réalisations par device
  function moreLoadRealizations() {
    if (window.matchMedia("(max-width:767px)").matches) {
      $(".blockrealization").slice(0, 1).show();
    } else if (window.matchMedia("(max-width:1024px)").matches) {
      $(".blockrealization").slice(0, 2).show();
    } else {
      $(".blockrealization").slice(0, 4).show();
    }
    if ($(".blockrealization:hidden").length == 0) {
      $("#load-more").hide();
    }
    $("#load-more").on('click', function (e) {
      e.preventDefault();
      if (window.matchMedia("(max-width:767px)").matches) {
        $(".blockrealization:hidden").slice(0, 1).show();
      } else if (window.matchMedia("(max-width:1024px)").matches) {
        $(".blockrealization:hidden").slice(0, 2).show();
      } else {
        $(".blockrealization:hidden").slice(0, 4).show();
      }
      if ($(".blockrealization:hidden").length == 0) {
        $("#load-more").hide();
      } else {
        $('html,body').animate({
          scrollTop: parseInt($(this).offset().top) - 800
        }, 700);
      }
    });
  }

  // Fonction qui permet de montrer la vidéo dans les blocs vidéos avec couverture image
  function showVideo() {
    if (!($(this).hasClass('showVideo'))) {
      $(this).addClass('showVideo');
      $('.blockvideo-iframe').animate({top: '0'}, 1500);
    }
  }

  // Fonction pour afficher le menu burger
  function showMenu() {
    if ($(this).hasClass('active')) {
      $(this).removeClass('active');
      $('.responsiv-menu').removeClass('active');
      $('html').removeAttr('style');
    } else {
      $(this).addClass('active');
      $('.responsiv-menu').addClass('active');
      $('html').css('overflow', 'hidden')
    }
  }

  // Fonction pour afficher le sous menu en mobile
  function showUnderMenu() {
    if ($(this).hasClass('active')) {
      $(this).removeClass('active')
      $(this).siblings('ul').removeClass('active')
    } else {
      $(this).addClass('active')
      $(this).siblings('ul').addClass('active')
    }
  }

  // Fonction pour minifier le header
  function minifyHeader() {
    // Scroll
    if ($(window).width() > 1200) {
      if ($('.main')[0]) {
        if (!$('.header').hasClass('minify') && $(window).scrollTop() >= $('.main').offset().top) {
          $('.header').addClass('minify')
          $('.aside-widjet, .more-than-pro.fixed').addClass('active')
        } else {
          if ($(window).scrollTop() <= $('.header').height()) {
            $('.header').removeClass('minify')
            $('.aside-widjet, .more-than-pro.fixed').removeClass('active')
          }
        }
      }
    } else {
      $('.header').removeClass('minify');
      $('.aside-widjet, .more-than-pro.fixed').removeClass('active')
    }
  }

  // Fonction pour enlever le minifier le header
  function removeMinifyHeader() {
    // Resize Width
    if ($(window).width() < 1200) {
      $('.header').removeClass('minify');
      $('.aside-widjet, .more-than-pro.fixed').removeClass('active')
    }
  }

  // Fonction pour faire apparaitre le sous menu de la navigation principale sur mobile
  function showSubMenu(e) {
    if ($(this).parent('li').parent('ul').parent().parent().hasClass('mobile-collapse')) {
      e.preventDefault();
    }
    if ($(this).hasClass('active')) {
      $(this).removeClass('active')
      $(this).next('ul').removeClass('active')
      $(this).next('.we-mega-menu-submenu').removeClass('active')
    } else {
      $(this).addClass('active')
      $(this).next('ul').addClass('active')
      $(this).next('.we-mega-menu-submenu').addClass('active')
    }
  }

  // IE / Edge pour les images sensibles alors que la propriété 'object-fit' n'est pas prise en charge
  function objectFitIt() {
    $('img.img-obj-fit').each(function () {
      var imgSrc = $(this).attr('src');
      var fitType = 'cover';

      if ($(this).data('fit-type')) {
        fitType = $(this).data('fit-type');
      }

      $(this).parent().css({'background': 'transparent url("' + imgSrc + '") no-repeat center center/' + fitType,});
      $('img.img-obj-fit').css('display', 'none');
    });
  }

  // Fonction pour scrool pour en voir plus
  function seeMore(e) {
    e.preventDefault();
    $('body, html').animate({
      scrollTop: $('section').first().next('section').offset().top - 300
    }, 2000)
  }

  // Fonction du slider d'accueil
  function sliderHome() {
    $('.slider-tabs .slider-home-slides').slick({
      autoplay: true,
      slidesToShow: 1,
      infinite: false,
      speed: 2000,
      dots: false,
      slidesToScroll: 1,
      arrows: false,
      asNavFor: '.slider-home-footer-slides',
    });
    $('.slider-tabs .slider-home-footer-slides').slick({
      slidesToShow: 3,
      slidesToScroll: 1,
      asNavFor: '.slider-home-slides',
      dots: false,
      arrows: false,
      focusOnSelect: true
    });
    $('.slider-arrow .slider-home-slides').slick({
      autoplay: true,
      slidesToShow: 1,
      infinite: false,
      speed: 2000,
      dots: true,
      slidesToScroll: 1,
      arrows: true,
    });
  }

  // Fonction du slider accueil mini simple
  function sliderHomeMini() {
    $(".slider-arrow-mini .slider-home-slides").slick({
      lazyLoad: 'ondemand',
      autoplay: true,
      slidesToShow: 1,
      infinite: true,
      speed: 2000,
      dots: false,
      slidesToScroll: 1,
      arrows: true
    });
  }

  // Fonction du slider de produit
  function sliderProduct() {
    $('.slider-product-slides').slick({
      autoplay: true,
      slidesToShow: 1,
      infinite: true,
      speed: 500,
      dots: false,
      slidesToScroll: 1,
      arrows: false,
      fade: true,
      cssEase: 'linear',
      asNavFor: '.slider-product-slides-thumbnail',
    });
    $('.slider-product-slides-thumbnail').slick({
      slidesToShow: 5,
      slidesToScroll: 1,
      asNavFor: '.slider-product-slides',
      dots: false,
      focusOnSelect: true,
      variableWidth: true,
      responsive: [
        {
          breakpoint: 500,
          settings: {
            variableWidth: false,
          }
        }
      ]
    });
  }

  // Fonction d'onglet de produit
  function tabsProducts() {
    $('#blockproductdetailtabs-level-1 ul.tabs li').click(function () {
      var tabID = $(this).attr('data-tab');

      $('#blockproductdetailtabs-level-1 ul.tabs li').removeClass('current');
      $('#blockproductdetailtabs-level-1 .tab-content').removeClass('current');

      $(this).addClass('current');
      $("#blockproductdetailtabs-level-1 #" + tabID).addClass('current');
    });

    $('#blockproductdetailtabs-level-2 ul.tabs li').click(function () {
      var tabID = $(this).attr('data-tab');

      $('#blockproductdetailtabs-level-2 ul.tabs li').removeClass('current');
      $('#blockproductdetailtabs-level-2 .tab-content').removeClass('current');

      $(this).addClass('current');
      $("#blockproductdetailtabs-level-2 #" + tabID).addClass('current');
    });

    $('#blockproductdetailtabs-level-3 ul.tabs li').click(function () {
      var tabID = $(this).attr('data-tab');

      $('#blockproductdetailtabs-level-3 ul.tabs li').removeClass('current');
      $('#blockproductdetailtabs-level-3 .tab-content').removeClass('current');

      $(this).addClass('current');
      $("#blockproductdetailtabs-level-2 #" + tabID).addClass('current');
    });

    $('#blockproductdetailtabs-level-4 ul.tabs li').click(function () {
      var tabID = $(this).attr('data-tab');

      $('#blockproductdetailtabs-level-4 ul.tabs li').removeClass('current');
      $('#blockproductdetailtabs-level-4 .tab-content').removeClass('current');

      $(this).addClass('current');
      $("#blockproductdetailtabs-level-4 #" + tabID).addClass('current');
    });
  }

  // Fonction du slider photo
  function sliderPhoto() {
    $('.slider-photo').slick({
      centerMode: true,
      infinite: true,
      centerPadding: '90px',
      slidesToShow: 3,
      speed: 500,
      variableWidth: false,
      dots: true,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 3,
          }
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 2,
          }
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
          }
        }
      ]
    });
    $('.slider-text-photo').slick({
      infinite: true,
      slidesToShow: 1,
      lidesToScroll: 1,
      arrow: true,
      variableWidth: false,
      dots: true,
    });
  }

  // Fonction de vérification du formulaire du Rendez-vous "Mon projet"
  function verifFormRDV(e) {
    var nbChampVide = 0;
    $('div.error').remove();
    $('select.error').removeClass('error');
    $('select.valid').removeClass('valid');
    $('input.error').removeClass('error');
    $('input.form-error').removeClass('form-error');
    $('input.valid').removeClass('valid');

    // Etape 1 - Mon projet
    var total_choix_de_la_pergola = $("input[name$='choix_de_la_pergola']").length;
    $("input[name$='choix_de_la_pergola']").each(function (index) {
      if ($("input[name$='choix_de_la_pergola']:checked").length < 1) {
        if (index === total_choix_de_la_pergola - 1) {
          $('#edit-choix-de-la-pergola--wrapper').before('<div class="error">' + $(this).attr('data-webform-required-error') + '</div>');
          $('.error').fadeIn();
          nbChampVide++;
        }
      }
    });

    // Etape 2 - Mes delais
    var total_profiter_de_votre_pergola = $("input[name$='profiter_de_votre_pergola']").length;
    $("input[name$='profiter_de_votre_pergola']").each(function (index) {
      if ($("input[name$='profiter_de_votre_pergola']:checked").length < 1) {
        if (index === total_profiter_de_votre_pergola - 1) {
          $('#edit-profiter-de-votre-pergola--wrapper').before('<div class="error">' + $(this).attr('data-webform-required-error') + '</div>');
          $('.error').fadeIn();
          nbChampVide++;
        }
      }
    });

    // Etape 3 - Mon budget
    var total_choix_du_budget = $("input[name$='choix_du_budget']").length;
    $("input[name$='choix_du_budget']").each(function (index) {
      if ($("input[name$='choix_du_budget']:checked").length < 1) {
        if (index === total_choix_du_budget - 1) {
          $('#edit-choix-du-budget--wrapper').before('<div class="error">' + $(this).attr('data-webform-required-error') + '</div>');
          $('.error').fadeIn();
          nbChampVide++;
        }
      }
    });

    // Liste déroulante Besoin d'un financement
    $('#edit-etape-3-mon-budget select.required').each(function () {
      if ($(this).val() == '' || $(this).val() == ' ') {
        $(this).addClass('error');
        $(this).parent().append('<div class="error">' + $(this).attr('data-webform-required-error') + '</div>');
        $('.error').fadeIn();
        nbChampVide++;
      }
    });

    // Etape 4 - Notre rendez-vous
    $('#calendrier_des_rendez_vous_table input:not(.edit-submit)').each(function () {
      if ($(this).attr('required') == 'required') {
        var textError = $(this).attr('data-webform-required-error');
        if ($(this).val() == "" || $(this).val() == " ") { // On vérifie que le champ n'est pas vide
          nbChampVide++;
          $(this).addClass('error');
          $(this).parent().append("<div class='error'></div>");
          $('.error').fadeIn();
        }
      }
    });

    $('#edit-section-4-etape-4 input:not(.edit-submit)').each(function () {
      if ($(this).attr('required') == 'required') {
        var textError = $(this).attr('data-webform-required-error');
        if ($(this).val() == "" || $(this).val() == " ") { // On vérifie que le champ n'est pas vide
          nbChampVide++;
          $(this).addClass('form-error');
          $(this).parent().append("<div class='error'>" + textError + "</div>");
          $('.error').fadeIn();
        } else { // S'il n'est pas vide on vérifie s'il y a une verification supplémentaire sur le champ
          var name = $(this).attr('name');
          if (name == 'email') {
            var regex = /[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}/igm;
            if (regex.test($(this).val()) == false) {
              nbChampVide++;
              $(this).addClass('form-error');
              $(this).parent().append("<div class='error'>Veuillez renseigner une adresse email valide.</div>");
              $('.error').fadeIn();
            } else {
              $(this).addClass('valid');
            }
          } else if (name == 'telephone') {
            var regexPhone = /^((\+|00)33\s?|0)[1-9](\s?\d{2}){4}$/;
            if (regexPhone.test($(this).val()) == false) {
              nbChampVide++;
              $(this).addClass('form-error');
              $(this).parent().append("<div class='error'>Veuillez renseigner un numéro de téléphone valide.</div>");
              $('.error').fadeIn();
            } else {
              $(this).addClass('valid');
            }
          } else {
            $(this).addClass('valid');
          }
        }
      }
    });

    // On vérifie que reCaptcha
    var $captcha = $('.g-recaptcha'),
      response = grecaptcha.getResponse();
    if (response.length === 0) {
      $('.g-recaptcha').after("<div class='error'>Veuillez cocher le captcha obligatoire.</div>");
      nbChampVide++;
    } else {
      $('.msg-error').text('');
      $captcha.removeClass("error");
    }

    // On vérifie que l'utilisateur a coché les cases RGPD
    $(".input[name$='rgpd'].required").each(function () {
      if ($(this).prop("checked") == false) {
        $(this).parent().children('label').after('<div class="error">' + $(this).attr('data-webform-required-error') + '</div>');
        $('.error').fadeIn();
        nbChampVide++;
      }
    });


    if (nbChampVide != 0) {
      e.preventDefault();
      $("html, body").animate({scrollTop: $('.error').offset().top - 125}, 500);
    } else {

    }
  }

  // Fonction de vérification du formulaire de Contact Basique
  function verifFormContact(e) {
    var nbChampVide = 0;
    $('div.error').remove();
    $('select.error').removeClass('error');
    $('select.valid').removeClass('valid');
    $('input.error').removeClass('error');
    $('textarea.error').removeClass('error');
    $('input.form-error').removeClass('form-error');
    $('textarea.form-error').removeClass('form-error');
    $('input.valid').removeClass('valid');


    // On vérifie la saisie des champs obligatoire
    $('.webform-submission-contact-form input:not(.edit-actions-submit), .webform-submission-demande-de-catalogue-form input:not(.edit-actions-submit)').each(function () {
      if ($(this).attr('required') == 'required') {
        var textError = $(this).attr('data-webform-required-error');
        if ($(this).val() == "" || $(this).val() == " ") { // On vérifie que le champ n'est pas vide
          nbChampVide++;
          $(this).addClass('form-error');
          $(this).parent().append("<div class='error'>" + textError + "</div>");
          $('.error').fadeIn();
        } else { // S'il n'est pas vide on vérifie s'il y a une verification supplémentaire sur le champ
          var name = $(this).attr('name');
          if (name == 'email') {
            var regex = /[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}/igm;
            if (regex.test($(this).val()) == false) {
              nbChampVide++;
              $(this).addClass('form-error');
              $(this).parent().append("<div class='error'>Veuillez renseigner une adresse email valide.</div>");
              $('.error').fadeIn();
            } else {
              $(this).addClass('valid');
            }
          } else if (name == 'telephone') {
            var regexPhone = /^((\+|00)33\s?|0)[1-9](\s?\d{2}){4}$/;
            if (regexPhone.test($(this).val()) == false) {
              nbChampVide++;
              $(this).addClass('form-error');
              $(this).parent().append("<div class='error'>Veuillez renseigner un numéro de téléphone valide.</div>");
              $('.error').fadeIn();
            } else {
              $(this).addClass('valid');
            }
          } else {
            $(this).addClass('valid');
          }
        }
      }
    });

    // Champ Textarea
    $('textarea:not(.webform-submission-contact-add-form  .edit-actions-submit)').each(function () {
      if ($(this).attr('required') == 'required') {
        var textError = $(this).attr('data-webform-required-error');
        if ($(this).val() == "" || $(this).val() == " ") { // On vérifie que le champ n'est pas vide
          nbChampVide++;
          $(this).addClass('form-error');
          $(this).parent().append("<div class='error'>" + textError + "</div>");
          $('.error').fadeIn();
        }
      }
    });

    // On vérifie que reCaptcha
    var $captcha = $('.g-recaptcha'),
      response = grecaptcha.getResponse();
    if (response.length === 0) {
      $('.g-recaptcha').after("<div class='error'>Veuillez cocher le captcha obligatoire.</div>");
      nbChampVide++;
    } else {
      $('.msg-error').text('');
      $captcha.removeClass("error");
    }

    if (nbChampVide != 0) {
      e.preventDefault();
      $("html, body").animate({scrollTop: $('.error').offset().top - 125}, 500);
    } else {

    }
  }

  function callFormLandingPage() {
    $(".g-recaptcha-bubble-arrow").parent().addClass('g-recaptcha-puzzle');

    $("html").css({'overflow': 'hidden', 'position': 'fixed', 'height': '100%', 'width': '100%'});
    $("body").css({'overflow': 'hidden', 'height': '100%', 'width': '100%'});
    $("body").addClass('open-form-landing');

    var heightScroll = window.innerHeight - $(".section-right-header").height();
    //alert(heightScroll);
    //alert(window.innerHeight);
    $('.section-right').css({"transform": "translate(0px)", "height": "100vh"});
    var styles = {
      "height": heightScroll + "px",
      "overflow-x": "scroll",
      top: "0"
    };

    $('#souhaite-une-etude').css(styles);
  }

  function closeFormLandingPage() {
    $("html").removeAttr('style');
    $("body").removeAttr('style');
    $("body").removeClass('open-form-landing');
    $('.section-right').removeAttr('style');
    $('#souhaite-une-etude').removeAttr('style');
  }

  document.addEventListener("DOMContentLoaded", function(event) {
    var classname = $('.language-cbo:not(.is-active)');
    for (var i = 0; i < classname.length; i++) {
      classname[i].addEventListener('click', obfuscation, false);
    }
  });

  function obfuscation(event) {
    var attribute = this.getAttribute("data-cbo");
    if(event.ctrlKey) {
      var newWindow =
        window.open(decodeURIComponent(window.atob(attribute)), '_blank');
      newWindow.focus();
    } else {
      document.location.href=
        decodeURIComponent(window.atob(attribute));
    }
  }

})(jQuery);

